export const CHILDCARE_ROUTES = {
	attendance: "/app/childcare",
	children: "/app/childcare/children",
	childDetail: "/app/childcare/children/:childId",
	reports: "/app/childcare/reports",
	terms: "/app/childcare/terms",
	myChildren: "/app/my-childcare",
} as const;

export function childDetailPath(childId: string): string {
	return `/app/childcare/children/${childId}`;
}
